import axios from 'axios';
import { getToken } from './auth';
const API_BASE = process.env.REACT_APP_API_URL || '/api';
export async function withdrawMeasurementCapability(withdrawalKey: string) {
  await axios.post(`${API_BASE}/public/measurement/withdraw`, {withdrawalKey});
}
export async function withdrawAccountMeasurement() {
  await axios.post(`${API_BASE}/measurement/withdraw`, {}, {headers: {Authorization: `Bearer ${getToken()}`}});
}
